export default {
  nav: {
    brand: 'Cemil Kuaför | Hair Design',
    videos: 'Videolar',
    gallery: 'Galeri',
    services: 'Hizmetler',
    contact: 'İletişim',
  },
  hero: {
    title: "Marmaris'te Doğal Görünümlü Mikro Kaynak",
    subtitle:
      'Saçınıza hacim, uzunluk ve doğal görünüm kazandıran profesyonel hair design uygulamaları.',
    btnVideos: 'Videoları İzle',
    btnWhatsApp: "WhatsApp'tan Soru Sor",
  },
  videos: {
    title: 'Uygulama Videoları',
    subtitle: 'Mikro kaynak sonuçlarımızı keşfedin',
    items: [
      { title: 'Mikro Kaynak Sonucu', duration: '0:32' },
      { title: 'Doğal Geçiş', duration: '0:28' },
      { title: 'Hacimli Saç Görünümü', duration: '0:35' },
      { title: 'Öncesi / Sonrası', duration: '0:41' },
      { title: 'Günlük Bakım Rutini', duration: '0:33' },
      { title: 'Renk Canlandırma', duration: '0:30' },
      { title: 'Keratin Bakım Sonucu', duration: '0:36' },
      { title: 'Modern Perma Etkisi', duration: '0:29' },
      { title: 'Ombre Uygulaması', duration: '0:34' },
      { title: 'Parlak Saç Dokusu', duration: '0:31' },
      { title: 'Kesim ve Şekillendirme', duration: '0:37' },
      { title: 'Gelin Saçı Hazırlığı', duration: '0:40' },
      { title: 'Doğal Dalgalı Model', duration: '0:27' },
      { title: 'Yoğun Hacim Uygulaması', duration: '0:38' },
      { title: 'Yaratıcı Hair Design', duration: '0:42' },
    ],
    playIcon: 'Oynat',
    close: 'Kapat',
    askWhatsApp: 'WhatsApp\'tan soru sor',
  },
  beforeAfter: {
    title: 'Öncesi / Sonrası',
    subtitle: 'Mikro kaynak sonuçlarımız',
    items: [
      { label: 'Görünmez bağlantı', desc: 'Doğal ve fark edilmeyen uygulama' },
      { label: 'Doğal saç uyumu', desc: 'Kendi saçınızla birebir uyum' },
      { label: 'Hacimli görünüm', desc: 'Dolgun ve canlı saç etkisi' },
      { label: 'Uzun ve sağlıklı saç', desc: 'Profesyonel bakım sonucu' },
    ],
    contact: 'İletişime Geç',
  },
  why: {
    title: 'Neden Mikro Kaynak?',
    subtitle: 'Profesyonel hair design avantajları',
    items: [
      { title: 'Doğal görünüm', desc: 'Kendi saçınızdan ayırt edilemez' },
      { title: 'Saçla birebir uyum', desc: 'Renk ve doku tam uyum' },
      { title: 'Konforlu kullanım', desc: 'Ağır hissettirmeyen hafif sistem' },
      { title: 'Profesyonel uygulama', desc: 'Yılların deneyimiyle güvenli işlem' },
      { title: "Marmaris'te deneyimli hizmet", desc: 'Yerli ve yabancı misafirlere özel bakım' },
    ],
  },
  services: {
    title: 'Hizmetlerimiz',
    subtitle: 'Premium hair design uygulamaları',
    items: [
      {
        title: 'Mikro Kaynak',
        desc: 'Doğal görünümlü, hafif ve konforlu saç uzatma sistemi. Görünmez bağlantılarla kendi saçınızdan ayırt edilemez.',
        badge: 'Popüler',
      },
      {
        title: 'Ombre',
        desc: 'Modern ve doğal geçişli renk teknikleri. Saçınıza derinlik ve hareket kazandıran profesyonel boyama.',
      },
      {
        title: 'Kalıcı Fön',
        desc: 'Uzun süre kalıcı, şekilli ve parlak saç görünümü. Nem ve dalgalanmaya karşı dayanıklı profesyonel işlem.',
      },
    ],
    askPrice: 'Fiyat ve detay sor',
    viewDetails: 'Detayları Gör',
  },
  tourist: {
    title: "Marmaris'te Profesyonel Hair Design Deneyimi",
    desc: "Marmaris'te yerli ve yabancı misafirler için profesyonel kuaför ve hair design deneyimi. Yılların tecrübesiyle her saç tipine özel çözümler sunuyoruz.",
    stats: [
      { value: '15+', label: 'Yıllık Deneyim' },
      { value: '5000+', label: 'Mutlu Müşteri' },
      { value: '3', label: 'Dil Desteği' },
    ],
  },
  salon: {
    title: 'Salon Bilgileri',
    name: 'Cemil Kuaför | Hair Design',
    address: 'Tepe Mah. DenizBank üzeri',
    city: 'Marmaris / Muğla',
    phone: '0531 345 99 87',
    instagram: '@cemilkuaformarmaris',
    hours: 'Her gün 09:00 - 20:00',
    getDirections: 'Yol Tarifi Al',
  },
  whatsapp: {
    cta: "WhatsApp'tan Soru Sor",
    message: 'Merhaba Cemil Kuaför, mikro kaynak uygulaması hakkında bilgi almak istiyorum.',
    floatingLabel: 'Bize Yazın',
  },
  faq: {
    title: 'Sıkça Sorulan Sorular',
    subtitle: 'Mikro kaynak, ombre ve kalıcı fön hakkında merak edilenler',
    items: [
      {
        q: 'Mikro kaynak ne kadar süre dayanır?',
        a: 'Profesyonel uygulama ve düzenli bakımla mikro kaynak 3–6 ay arası sorunsuz kullanılabilir. Periyodik bakım randevularıyla ömrü uzatılır.',
      },
      {
        q: 'Mikro kaynak kendi saçıma zarar verir mi?',
        a: 'Hayır. Doğru uygulama teknikleriyle kendi saçınıza hiçbir zarar gelmez. Mikro kaynak saç köküne değil, saç telinin orta bölümüne uygulanır.',
      },
      {
        q: 'Ombre ve mikro kaynak aynı günde yapılabilir mi?',
        a: 'Evet, her iki işlem aynı seansta kombinlenebilir. Böylece tek randevuda hem renk hem uzunluk/hacim elde edebilirsiniz.',
      },
      {
        q: 'Neden fiyatlar sitede belirtilmemiş?',
        a: 'Saç tipi, yoğunluk ve uzunluk kişiden kişiye değiştiği için net fiyat vermek yerine WhatsApp üzerinden özel fiyat teklifi sunuyoruz.',
      },
      {
        q: 'Marmaris\'te tatilim sırasında hizmet alabilir miyim?',
        a: 'Kesinlikle evet. Yerli ve yabancı tüm misafirlere İngilizce ve Rusça destekli profesyonel hizmet sunuyoruz. Randevu almanız yeterli.',
      },
      {
        q: 'Mikro kaynak uygulaması ne kadar sürer?',
        a: 'Ortalama 2–4 saat arasında tamamlanır. Saçın yoğunluğu ve istenilen uzunluk bu süreyi etkiler.',
      },
      {
        q: 'Kalıcı fön ne kadar dayanır?',
        a: 'Kalıcı fön uygulaması 3–6 ay etkili olur. Düzleştirici ve şekillendirici bakım gereksinimi azalır.',
      },
      {
        q: 'Randevu nasıl alabilirim?',
        a: 'Sayfadaki WhatsApp butonlarından bize yazarak veya telefonla arayarak kolayca randevu alabilirsiniz.',
      },
      {
        q: 'Saç boyama öncesi nelere dikkat etmeliyim?',
        a: 'Boyama öncesi saçın temiz olması yeterli. Uzman ekibimiz işlem öncesi saç analizi yaparak en uygun tekniği belirler.',
      },
      {
        q: 'Mikro kaynak sonrası bakım nasıl olmalı?',
        a: 'Özel şampuan ve bakım ürünleri öneriyoruz. Düzenli tarama, ısı koruyucu kullanımı ve bakım randevuları uzun ömür sağlar.',
      },
    ],
  },
  testimonials: {
    title: 'Müşteri Memnuniyeti',
    subtitle: 'Mikro kaynak uygulaması yaptıran müşterilerimizin yorumları',
    items: [
      {
        name: 'Ayşe K.',
        role: 'Marmaris',
        text: 'Mikro kaynak uygulaması sonrası saçlarım çok doğal görünüyor. Kimse ek saç olduğunu fark etmiyor. Tuncer Bey\'in profesyonelliği gerçekten çok farklı.',
        service: 'Mikro Kaynak',
      },
      {
        name: 'Elena S.',
        role: 'Moskova',
        text: 'Marmaris tatilim sırasında gelmiştim, sonuç mükemmeldi. Rusça destek de sağlanıyor olması çok rahatlatıcıydı. Kesinlikle tavsiye ederim!',
        service: 'Ombre + Mikro Kaynak',
      },
      {
        name: 'Jennifer M.',
        role: 'İngiltere',
        text: 'I was amazed by the natural look of the micro link extensions. Cemil and his team made me feel so welcome. Highly recommended for English-speaking tourists!',
        service: 'Micro Link Extensions',
      },
      {
        name: 'Büşra T.',
        role: 'Muğla',
        text: 'Kalıcı fön ve mikro kaynak beraber yapıldı. Saçlarım artık her sabah hazır. Fön çekme derdim tamamen bitti. Çok memnun kaldım.',
        service: 'Kalıcı Fön + Mikro Kaynak',
      },
      {
        name: 'Olga P.',
        role: 'Rusya',
        text: 'Прекрасная работа! Волосы выглядят совершенно натурально. Салон очень уютный, персонал профессиональный. Обязательно приду снова в следующем году.',
        service: 'Микро-накладки',
      },
      {
        name: 'Fatma D.',
        role: 'Marmaris',
        text: '6 aydır mikro kaynak kullanıyorum. Hala ilk günkü gibi. Bant ve keratin sistemler kullanmıştım, mikro kaynak çok daha rahat ve doğal.',
        service: 'Mikro Kaynak',
      },
    ],
    verified: 'Doğrulanmış Yorum',
    stars: '5.0',
  },
  footer: {
    copyright: '© 2026 Cemil Kuaför | Hair Design. Tüm hakları saklıdır.',
    followUs: 'Bizi Takip Edin',
  },
  videoDetails: {
    askMessage: 'Merhaba, {{title}} hakkında bilgi ve randevu almak istiyorum.',
    durationLabel: 'İşlem Süresi',
    resultLabel: 'Sonuç Türü',
    guaranteeLabel: 'Garanti',
    detailsTitle: 'İşlem Detayları',
    advantagesTitle: 'Avantajlar',
    targetAudienceTitle: 'Kimler İçin Uygun',
    items: [
      {
        title: 'Mikro Kaynak Uygulaması',
        subtitle: 'Doğal görünümlü, saça zarar vermeyen premium kaynak uygulaması.',
        duration: '2-4 saat',
        resultType: 'Doğal Sonuç',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Bu ay 156 kişi mikro kaynak için randevu aldı',
        socialProofSub: 'Son 30 günde yoğun talep görüyor',
        description:
          `Doğal geçişlerle sadeliğin en şık hali ✨\nSaçın içine minik ışıltılar dokunduk, abartısız ama fark yaratan bir görünüm 🌿\nIşığı yakalayan yumuşacık tonlarla, her açıdan zarif 💫`,
        advantages: [
          'Saça hiçbir kimyasal işlem uygulanmaz',
          'Doğal saç ile birebir görünüm sağlar',
          'Yıkanabilir, ütülenebilir, boyanabilir',
          'Saç derisinde ağırlık hissi yaratmaz',
          'Profesyonel söküm ile yeniden kullanılabilir',
        ],
        targetAudience: [
          'İnce telli saçlara hacim isteyenler',
          'Boy uzatma isteyenler',
          'Türbanlı kullanıma uygun',
          'Günlük bakımı kolay isteyenler',
        ],
      },
      {
        title: 'Ombre ve Renk İşlemleri',
        subtitle: 'Doğal geçişli, modern renk teknikleriyle premium sonuç.',
        duration: '1,5-2,5 saat',
        resultType: 'Uzun Süreli',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 30 günde 98 kişi ombre işlemi yaptırdı',
        socialProofSub: 'Kış sezonunda favori renk işlemi',
        description:
          `Soft Luxury Dalga Dokunuşu ✨\n\nIşıltı bağırmaz… kendini hissettirir. Dalgalı kaynak saç ile o zahmetsiz şıklık tam olarak bu 💫 Hacimli, hareketli ve inanılmaz doğal duran dalgalarla saçın her an hazır, her an kusursuz.\n\nNe abartı ne sönük… Tam kararında bir lüks hissi. Günlük kombinine bile üst segment bir hava katarken, özel anlarda zaten tüm dikkat sende 🖤\n\nKaliteyi saçında hissetmek isteyenler için en doğru dokunuş burada. Çünkü gerçek lüks, detaylarda saklı ✨`,
        advantages: [
          'Doğal ışıltı ve derinlik efekti verir',
          'Sadece uç renklendirme ile minimum zarar',
          'Uzun süre solmadan kalır',
          'Bakım gerektirmeden günlük şıklık',
          'Tekrar uygulamada kolay geçiş imkanı',
        ],
        targetAudience: [
          'Modern görünüm sevenler',
          'Bakımı kolay renk arayanlar',
          'Uzun süreli sonuç isteyenler',
          'Ten rengine uygun ton arayanlar',
        ],
      },
      {
        title: 'Kalıcı Fön ve Keratin Bakım',
        subtitle: 'Günlük şekillendirme derdine son, pürüzsüz ve parlak saçlar.',
        duration: '2-3 saat',
        resultType: '6-8 Ay Etki',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Bugüne kadar 2.140 kişi bu bakımı yaptırdı',
        socialProofSub: 'Son 6 ayda en çok tercih edilen işlem',
        description:
          `Marmaris’te profesyonel saç kaynak işlemi denince akla gelen ilk adreslerden biri olan Cemil Kuaför’de, saçına en uygun yöntem özenle belirlenir ve tamamen doğal bir sonuç elde edilir.\n\nKullandığımız kaliteli saçlar ve uzman uygulama sayesinde hem konforlu hem de uzun süreli bir kullanım sağlanır. Günlük hayatında rahatça kullanabileceğin, kendi saçından ayırt edilemeyecek kadar doğal bir görünüm seni bekliyor ✨`,
        advantages: [
          'Günlük şekillendirme süresini %90 azaltır',
          'Nem ve yağmura karşı direnç sağlar',
          'Saç tellerini derinlemesine besler',
          'Parlaklık ve pürüzsüzlük verir',
          'Doğal hareket kaybetmeden düzleştirir',
        ],
        targetAudience: [
          'Kıvırcık ve dalgalı saçlar',
          'Fön çekmekten yorulanlar',
          'Nemlendirme ihtiyacı olan saçlar',
          'Günlük kolaylık arayanlar',
        ],
      },
      {
        title: 'Yeni Nesil Perma',
        subtitle: 'Saça hacim ve belirgin dalga kazandıran modern perma uygulaması.',
        duration: '2,5-3,5 saat',
        resultType: 'Uzun Süreli',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Bugüne kadar 1.720 kişi modern perma yaptırdı',
        socialProofSub: 'Son 24 saatte yoğun ilgi görüyor',
        description:
          `Doğallık, hacim ve kusursuz geçiş… ✨\nHer bir uygulamada saçın yapısına özel çalışıyoruz\nÇünkü herkesin dönüşümü kendine özel olmalı 💫\nSonuç? Işıltısını geri kazanan saçla`,
        advantages: [
          'Saça hacim kazandırır',
          'Belirgin ve estetik dalga görünümü sağlar',
          'Daha dolgun saç görünümü oluşturur',
          'Günlük şekillendirme süresini azaltır',
          'Saç tipine uygun teknikle uygulanır',
        ],
        targetAudience: [
          'Hacimsiz saçlar',
          'Dalgalı görünüm isteyenler',
          'Şekil alan saç isteyenler',
          'Günlük stil arayanlar',
        ],
      },
      {
        title: 'Günlük Saç Bakımı',
        subtitle: 'Saç sağlığını koruyan, günlük uygulanabilir pratik bakım rutini.',
        duration: '45-60 dk',
        resultType: 'Anında Parlaklık',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Bu hafta 73 kişi günlük bakım paketi aldı',
        socialProofSub: 'Yoğun talep gören hızlı bakım hizmeti',
        description:
          `Uzun, dolgun, kusursuz ✨\nSaçların sadece görünüşün değil, enerjin…\nBiz de o enerjiyi baştan yaratıyoruz 💫\n\nİncecik, fark edilmeyen, tamamen doğal duran mikrokaynaklarla\nsaçlarına hacim, uzunluk ve özgüven ekliyoruz 🤍\n\nAynaya baktığında “iyi ki” diyeceğin o an için buradayız…\nHer dokunuş profesyonel, her sonuç kusursuz ✨\n\nSen hayal et, biz gerçeğe dönüştürelim 💌`,
        advantages: [
          'Elektriklenmeyi önleyen formül',
          'Saç tellerini nemlendirir',
          'Hızlı uygulanabilir',
          'Günlük kullanıma uygun',
          'Saç sağlığını uzun vadeli korur',
        ],
        targetAudience: [
          'Yoğun tempoda çalışanlar',
          'Pratik bakım arayanlar',
          'Saç sağlığına önem verenler',
          'Günlük parlaklık isteyenler',
        ],
      },
      {
        title: 'Renk Canlandırma',
        subtitle: 'Mevcut renginizi tazeleyen, canlı tonlar kazandıran hızlı boyama işlemi.',
        duration: '1-1,5 saat',
        resultType: 'Parlak Sonuç',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 14 günde 112 kişi renk canlandırma yaptırdı',
        socialProofSub: 'Favori hızlı renk işlemi',
        description:
          `Bir dokunuşla bambaşka… ✨\n\nYanmış, yıpranmış ve cansız saçlara veda ettik; yerine uzun, siyah ve göz alıcı bir görünüm kazandırdık. 🤍\nUyguladığımız profesyonel kaynak ile saçlar artık çok daha dolgun, sağlıklı ve bakımlı duruyor.\n\nSaç sadece görünüm değil, his meselesi…\nAynaya baktığında kendini daha güçlü ve güzel hissetmen için buradayız. 🖤`,
        advantages: [
          'Solmuş renkleri canlandırır',
          'Parlaklık ve derinlik verir',
          'Minimum kimyasal kullanımı',
          'Hızlı uygulanabilir',
          'Saç yapısına zarar vermez',
        ],
        targetAudience: [
          'Solmuş renk sahipleri',
          'Parlaklık arayanlar',
          'Hızlı sonuç isteyenler',
          'Mevcut rengini korumak isteyenler',
        ],
      },
      {
        title: 'Yoğun Keratin Bakımı',
        subtitle: 'Saç tellerini derinlemesine onaran, uzun süreli yumuşaklık sunan özel bakım.',
        duration: '1,5-2 saat',
        resultType: '3-4 Ay Etki',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 30 günde 215 kişi keratin bakımı yaptırdı',
        socialProofSub: 'Kış sezonunun vazgeçilmez bakımı',
        description:
          `Işıltı tesadüf değil… doğru dokunuşların eseri. ✨\n\nSaç sadece saç değildir; bir kadının enerjisi, özgüveni ve tarzının en güçlü yansımasıdır. Bu görünümde ise doğallıkla lüksün tam ortasındayız… 🤍\n\nÖzenle uygulanan kaynak işlemi sayesinde saçlar hem dolgunluk kazandı hem de bu yumuşacık, akışkan dalgalarla adeta hayat buldu. Her bir tutam, kendi saçınız gibi hissettiren konfor ve hafiflikle tasarlandı. 🌿\n\nIşığı yakalayan bu kahve tonları, yüz hatlarını ön plana çıkarırken; uzun, hacimli ve sağlıklı görünüm gün boyu etkisini kaybetmeden sizinle kalır. Çünkü biz sadece saç yapmıyoruz… size aynaya baktığınızda “iyi ki” dedirten bir his bırakıyoruz. 💫`,
        advantages: [
          'Kırık uçları onarır',
          'Elektriklenmeyi azaltır',
          'Saç tellerini güçlendirir',
          'Uzun süreli yumuşaklık sağlar',
          'Isı işlemlerine karşı korur',
        ],
        targetAudience: [
          'Yıpranmış saçlar',
          'Kırık uçlu saçlar',
          'Isı işlemi sık yapanlar',
          'Derinlemesine bakım arayanlar',
        ],
      },
      {
        title: 'Modern Perma Uygulaması',
        subtitle: 'Doğal dalgalar ve hacim kazandıran, saça şekil veren modern perma tekniği.',
        duration: '2-3 saat',
        resultType: '5-7 Ay Etki',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 7 günde 64 kişi perma yaptırdı',
        socialProofSub: 'Trend olan doğal dalga görünümü',
        description:
          `Mikrokaynak uygulamasıyla saçta kusursuz bir dönüşüm…\nUzunluk, hacim ve doğallığın en rafine haliyle buluştuğu özel bir dokunuş 💫\n\nHer bir tutam, saçınızın kendi yapısına uyum sağlayacak şekilde özenle uygulanır.\nEk yerleri görünmez, hissiyatı hafif ve sonucu tamamen doğal bir bütünlük sunar.\n\nKullandığımız profesyonel teknikler ve yüksek kalite saçlar sayesinde, sadece bir uygulama değil; kişiye özel, uzun süreli ve zarif bir görünüm elde edilir ✨\nAbartıdan uzak, ama etkisi ilk bakışta hissedilen bir değişim…\n\nMikrokaynak ile saçınızda sade ama güçlü bir fark yaratıyoruz.\nÇünkü gerçek lüks, doğallığın en kusursuz halidir 🤍`,
        advantages: [
          'Doğal dalga görünümü sağlar',
          'Saça hacim kazandırır',
          'Günlük şekillendirme kolaylaşır',
          'Uzun süre kalıcıdır',
          'Saç tipine özel uygulanır',
        ],
        targetAudience: [
          'Doğal dalga isteyenler',
          'Düz ve hacimsiz saçlar',
          'Günlük kolaylık arayanlar',
          'Modern görünüm sevenler',
        ],
      },
      {
        title: 'Ombre ve Balayage',
        subtitle: 'Doğal ışıltı efektiyle saç uçlarında zarif renk geçişleri.',
        duration: '2-3 saat',
        resultType: 'Uzun Süreli',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 60 günde 178 kişi ombre/balayage yaptırdı',
        socialProofSub: 'Tüm sezonlarda favori renk tekniği',
        description:
          `💁‍♀️ Saçınıza doğal ve kusursuz geçişli mikrokaynaklarla ekstra hacim, hareket ve özgün stil kazandırıyoruz.\n🌿 Tonları saç yapınıza özel seçiyoruz; daha canlı, parlak ve bakımlı bir görünüm garanti!\n💫 Günlük kullanımda kolay şekil alan, doğal ama göz alıcı hacimli saçlar.\n🔥 Profesyonel tekniklerle yapılan mikrokaynak, saçınıza uzun süre form ve enerji katıyor.`,
        advantages: [
          'Doğal renk geçişi sağlar',
          'Uç boyama ile kök korunur',
          'Uzun süre bakım gerektirmez',
          'Ten rengine uygun ton seçimi',
          'Modern ve şık görünüm',
        ],
        targetAudience: [
          'Doğal ışıltı arayanlar',
          'Kök boyası istemeyenler',
          'Modern görünüm sevenler',
          'Uzun süreli renk isteyenler',
        ],
      },
      {
        title: 'Saç Parlaklık Bakımı',
        subtitle: 'Saç tellerine anında parlaklık ve canlılık kazandıran özel serum bakımı.',
        duration: '30-45 dk',
        resultType: 'Anında Parlaklık',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Her gün ortalama 25 kişi parlaklık bakımı alıyor',
        socialProofSub: 'Hızlı ve etkili sonuçlarıyla çok tercih ediliyor',
        description:
          `Işıltı tesadüf değil, doğru dokunuşun sonucu…\nSaçta derinlik, parlaklık ve kusursuz geçişler için en doğru teknik: profesyonel kaynak uygulaması 💫\nHer tutam özenle yerleştirildi, doğal görünüm ve maksimum konfor hedeflendi.\nSonuç? Daha dolgun, daha hacimli ve tam anlamıyla kusursuz bir görünüm 🤍`,
        advantages: [
          'Anında parlaklık verir',
          'Saç canlılığını artırır',
          'Çok hızlı uygulanır',
          'Özel günler için ideal',
          'Saç yapısına zarar vermez',
        ],
        targetAudience: [
          'Hızlı sonuç arayanlar',
          'Özel etkinlikler için hazırlık',
          'Mat ve cansız saçlar',
          'Anında parlaklık isteyenler',
        ],
      },
      {
        title: 'Profesyonel Kesim ve Stil',
        subtitle: 'Yüz hatlarınıza uygun, modern ve kişiselleştirilmiş saç kesimi ve şekillendirme.',
        duration: '45-75 dk',
        resultType: 'Kalıcı Şekil',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Bu ay 340 kişi kesim ve stil hizmeti aldı',
        socialProofSub: 'Her zaman yoğun ilgi gören temel hizmet',
        description:
          `Doğallığın en kusursuz hali ✨\nMikro kaynak ile saçta hacim, uzunluk ve ipeksi bir ışıltı bir arada…\nKendi saçından ayırt edilemeyecek kadar doğal, hafif ve konforlu bir kullanım 🤍`,
        advantages: [
          'Yüz hatlarına uygun model',
          'Saç tipine özel teknik',
          'Günlük bakımı kolaylaştırır',
          'Modern ve trend görünüm',
          'Profesyonel şekillendirme dahil',
        ],
        targetAudience: [
          'Yeni model arayanlar',
          'Yüz hatlarına uygun kesim isteyenler',
          'Modern görünüm sevenler',
          'Günlük pratiklik arayanlar',
        ],
      },
      {
        title: 'Gelin Saçı ve Makyajı',
        subtitle: 'Hayal ettiğiniz gelin saçı için özel tasarım, prova ve uygulama hizmeti.',
        duration: '2-4 saat',
        resultType: 'Gün Boyu Kalıcı',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Bu sezon 89 gelin saçı tasarımı yaptık',
        socialProofSub: 'Düğün sezonunun en çok tercih edilen paketi',
        description:
          `💁‍♀️ Röfle uygulamasıyla saçınıza doğal ve yumuşak geçişli ışıltılar kazandırıyoruz.\n🌿 Saç yapınıza uygun tonlarla daha canlı, daha parlak ve bakımlı bir görünüm.\n💫 Günlük kullanımda kolay şekil alan, hacimli ve göz alıcı saçlar.\n✨ Uzun süre formunu koruyan profesyonel uygulamalar.`,
        advantages: [
          'Düğün öncesi prova imkanı',
          'Gelinlikle uyumlu tasarım',
          'Gün boyu kalıcı şekillendirme',
          'Özel saç aksesuarları kullanımı',
          'Fotoğraf ve video çekimine uygun',
        ],
        targetAudience: [
          'Gelin adayları',
          'Nişan ve özel gün hazırlığı',
          'Kalıcı şekillendirme isteyenler',
          'Profesyonel görünüm arayanlar',
        ],
      },
      {
        title: 'Doğal Dalgalı Model',
        subtitle: 'Isı kullanmadan, saçın doğal dokusunu ön plana çıkaran dalgalı şekillendirme.',
        duration: '45-60 dk',
        resultType: 'Gün Boyu Kalıcı',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 30 günde 56 kişi bu modeli tercih etti',
        socialProofSub: 'Doğal güzellik akımının gözdesi',
        description:
          `Saçlarınıza hak ettiği özeni verin… 🌿\nCemil Kuaför’de saç kaynak işlemleri, kişiye özel analizle uygulanır ve en doğal sonuç hedeflenir. 💇‍♀️✨\n\nIşıltılı, dolgun ve kusursuz görünen saçlarla özgüveninizi yeniden keşfedin. 💫`,
        advantages: [
          'Isı kullanmadan şekillendirir',
          'Saç sağlığını korur',
          'Doğal dalga görünümü sağlar',
          'Gün boyu kalıcıdır',
          'Günlük uygulanabilir',
        ],
        targetAudience: [
          'Doğal görünüm sevenler',
          'Isı işleminden kaçınanlar',
          'Saç sağlığına önem verenler',
          'Yumuşak dalga isteyenler',
        ],
      },
      {
        title: 'Yoğun Hacim Uygulaması',
        subtitle: 'İnce telli saçlara dolgunluk ve hacim kazandıran özel kesim ve şekillendirme.',
        duration: '1-1,5 saat',
        resultType: 'Anında Hacim',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 30 günde 134 kişi hacim uygulaması yaptırdı',
        socialProofSub: 'İnce telli saçların kurtarıcısı',
        description:
          `Hayalinizdeki uzun ve dolgun saçlar artık mümkün ✨\nCemil Kuaför’de profesyonel saç kaynak uygulamaları ile saçlarınıza yeni bir hayat veriyoruz 💇‍♀️💖\nDoğal görünüm, kusursuz uyum ve kalıcı sonuçlarla kendinizi yeniden keşfedin.`,
        advantages: [
          'Anında dolgunluk sağlar',
          'Saç köklerini kaldırır',
          'Özel hacim ürünleri ile desteklenir',
          'Günlük şekillendirme kolaylaşır',
          'Uzun süre etkili sonuç',
        ],
        targetAudience: [
          'İnce telli saçlar',
          'Hacim eksikliği olanlar',
          'Dolgun görünüm isteyenler',
          'Saç kökü kalkıklığı arayanlar',
        ],
      },
      {
        title: 'Yaratıcı Hair Design',
        subtitle: 'Kişiliğinizi yansıtan, özgün ve sanatsal saç tasarımları.',
        duration: '1,5-3 saat',
        resultType: 'Benzersiz Tasarım',
        guarantee: 'Memnuniyet Garantili',
        socialProof: 'Son 90 günde 47 kişi yaratıcı tasarım yaptırdı',
        socialProofSub: 'Özgün stil arayanların tercihi',
        description:
          `Cemil Kuaför’de saç kaynak işlemleri; sadece uzunluk değil, saç yapınıza, ten renginize ve stilinize en uygun doğal uyumu yakalamak için titizlikle planlanır. 💇‍♀️💫`,
        advantages: [
          'Tamamen kişiselleştirilmiş tasarım',
          'Renk ve kesim kombinasyonu',
          'Özgün ve sanatsal sonuç',
          'Profesyonel konsültasyon dahil',
          'Trend ve modern teknikler',
        ],
        targetAudience: [
          'Özgün stil arayanlar',
          'Sanatsal görünüm sevenler',
          'Renkli saç tercih edenler',
          'Benzersiz tasarım isteyenler',
        ],
      },
    ],
  },
};